<!-- <nav #navbar class="navbar navbar-expand-lg navbar-transparent  navbar-absolute" style="z-index: 70;top:10px"> -->
<nav #navbar class="navbar navbar-expand-lg navbar-transparent navbar-solser-shell">
  <div class="container-fluid">
    <div class="navbar-wrapper">
      <button
        type="button"
        (click)="toggleSidebarFromButton()"
        class="navbar-sidebar-toggle navbar-toggler"
        aria-label="Alternar menu lateral"
        title="Alternar menu lateral"
      >
        <i class="material-icons visible-on-sidebar-regular">menu</i>
        <i class="material-icons visible-on-sidebar-mini">view_list</i>
      </button>

      <a class="navbar-brand navbar-solser-brand" [routerLink]="['/dashboard']">
        <img class="navbar-solser-brand__mark" src="./assets/img/logohorizontalpng/logoA.png" alt="Solser" />
        <img class="navbar-solser-brand__wordmark" src="./assets/img/logohorizontalpng/logoB.png" alt="Solser Information Technology" />
      </a>

      <span class="navbar-page-title">{{getTitle()}}</span>
    </div>

    <div class="collapse navbar-collapse justify-content-end" id="navigation">
      <ul class="navbar-nav">
        <li class="nav-item navbar-user-item" *ngIf="pNombre">
          <button
            type="button"
            class="navbar-user-chip"
            (click)="abrePantalla()"
            aria-label="Abrir ajustes de usuario"
            title="Abrir ajustes de usuario"
          >
            <span class="navbar-user-chip__avatar">
              <img
                [src]="fotosidebar"
                alt=""
                (error)="fotosidebar = './assets/img/default-avatar.png'"
              />
            </span>
            <span class="navbar-user-chip__name">{{ pNombre }}</span>
          </button>
        </li>

        <li class="nav-item navbar-settings-item navbar-tema-item">
          <app-selector-tema vista="menu"></app-selector-tema>
        </li>

        <li class="nav-item navbar-settings-item">
          <a class="nav-link navbar-settings-link" href="javascript:void(0)" (click)="logout()">
            <i class="material-icons">logout</i>
          </a>
        </li>

        <li class="nav-item dropdown" [ngClass]="'campana'">
          <a class="nav-link" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="material-icons">notifications</i>
            <span class="notification">{{nuevas}}</span>
          </a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink" >

            <div class=' sin-notificaciones' *ngIf='nuevas == 0'> 
              <a  class="dropdown-item" >
                &nbsp;   &nbsp; <br> No se encontraron nuevas notificaciones  &nbsp;&nbsp;
              </a>
            </div>
                     <div class=' detalle'>
                        <a routerLink="/NOTIFICACION/detalle" routerLinkActive="active" class="btn btn-sm btn-outline-success">
                          <i class='material-icons'>format_list_bulleted</i> &nbsp; Ver detalles
                        </a>
                        <a href="javascript:void(0);" (click)="marcarVistoTodas()" class="btn btn-sm btn-outline-danger">
                          <i class='material-icons'>delete_forever</i> &nbsp; Eliminar todas
                        </a>
                    </div>

                    <ng-container matColumnDef="notificaciones" *ngIf='nuevas > 0' >                      
                        <a *ngFor="let item of notificaciones | slice:0:20"  class="dropdown-item"  (click)='marcarVisto(item.id)' 
                            matTooltip="Info about the action"
                           [matTooltipPosition]="right">
                           {{item.creacion }} &nbsp; {{item.tipo}} &nbsp; {{item.descripcion}} 
                        </a>    
                        <a href="javascript:void(0);" (click)='marcarVisto(item.id)'  >
                          <i class='material-icons'>close</i> 
                        </a>
                    </ng-container>
               
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>
